<template>
  <base-section
    id="camera-ready-industrial"
  >

    <v-container>
      <base-section-heading
      title="Camera-ready Instructions for Industrial Papers accepted for Informal Digest"
      >
      <div style="text-align: left !important">
       Below you find the instructions to submit your camera-ready version. In the case of questions or problems please contact the Publication Chairs (see bottom of this page).
       <br>
       <strong>Paper Format:</strong><br>
       • The maximum length of the camera-ready manuscript is 6 pages (for both oral and poster presentations)<br>
       • Paper must be in the IEEE proceedings two-column format (<strong>A4 size</strong>). You can find
<a href="https://www.ieee.org/conferences_events/conferences/publishing/templates.html">here</a> the templates provided by IEEE. Prior to submission, <strong> check if your PDF satisfies the A4 format (11.69×8.27in)</strong>. In Adobe Reader you can check this by clicking on file->properties and look for page size in the Description tab. <u><strong>Papers submitted in Letter format will not be considered.</strong></u><br>
       • <strong>Important!</strong> Do not include page numbers in your paper, a copyright footer information or any other headers or footers.<br>
       • Camera-ready upload must be done through the submission system <a
       target="_blank"
       href="https://welcome.molesystems.com/tttc/ETS/2023/main.php"
       >
       here</a> <br>
       • The deadline for camera ready upload is <strong>March 10th, 2023</strong>. <br>
      </div>
      </base-section-heading>

      <base-section-heading
      title="Contacts"
      >
      <v-row>
        <v-col
          v-for="(pub, i) in publications"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="pub"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      </base-section-heading>
      </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'CameraReadyIndustrial',

    data () {
    return {
      isMobile: false,
      submissionsfooter: [
        {
          name: 'Submissions',
          url: 'submissions',
        },
        {
          name: 'Key Dates',
          url: 'key-dates',
        },
        {
          name: 'Topics',
          url: 'topics',
        },
        {
          name: 'Submit a Paper',
          url: 'cfp',
        },
        {
          name: 'Submission Guidelines',
          url: 'submission-guidelines',
        },
      ],
      publications: [
        {
          title: 'Mottaqiallah Taouil',
          src: require('@/images/committees/taouil.jpg'),
          text: 'TU Delft, NL, m.taouil@tudelft.nl ',
        },
        {
          title: 'Tara Ghasempuori',
          src: require('@/images/committees/ghasempouri.jpg'),
          text: 'Taltech, EE, tara.ghasempouri@taltech.ee',
        },
      ],
    }
    },
    mounted () {
      //  this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
    },
    methods: {
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
    },
  }
</script>
